import React from "react";
import AccessSystemRevenueChart from "./AccessSystemRevenueChart";
import RevenueChart from "./RevenueChart";
import CheckinsChart from "./CheckinsChart";
import AverageStayDurationChart from "./AverageStayDurationChart";
import PaymentDistributionChart from "./PaymentDistributionChart";
import OccupancyChart from "./OccupancyChart";
import AgeGroupDistributionChart from "./AgeGroupDistributionChart";

const StatChart = ({ statChart }) => {
  if (statChart.type == "revenue") {
    return <RevenueChart revenueChart={statChart} />;
  }
  if (statChart.type == "access_system_revenue") {
    return <AccessSystemRevenueChart chart={statChart} />;
  }
  if (statChart.type == "checkins") {
    return <CheckinsChart checkinsChart={statChart} />;
  }
  if (statChart.type == "average_stay_duration") {
    return <AverageStayDurationChart averageStayDurationChart={statChart} />;
  }
  if (statChart.type == "payment_distribution") {
    return <PaymentDistributionChart paymentDistributionChart={statChart} />;
  }
  if (statChart.type == "occupancy") {
    return <OccupancyChart occupancyChart={statChart} />;
  }
  if (statChart.type == "age_group_distribution") {
    return <AgeGroupDistributionChart ageGroupDistributionChart={statChart} />;
  }
};

export default StatChart;
